export type ApiDosingMethodType = 'Pellet Dosing' | 'Cream Dosing' | 'Troche Dosing' | 'Injectable Dosing';

export enum DosingMethodEnum {
  PELLET = 'PELLET',
  CREAM = 'CREAM',
  TROCHE = 'TROCHE',
  INJECTABLE = 'INJECTABLE',
}

export const DosingMethodApiValueMap: Record<DosingMethodEnum, ApiDosingMethodType> = {
  [DosingMethodEnum.PELLET]: 'Pellet Dosing',
  [DosingMethodEnum.CREAM]: 'Cream Dosing',
  [DosingMethodEnum.TROCHE]: 'Troche Dosing',
  [DosingMethodEnum.INJECTABLE]: 'Injectable Dosing',
};

export const ApiValueToDosingMethodEnum: Record<ApiDosingMethodType, DosingMethodEnum> = {
  'Pellet Dosing': DosingMethodEnum.PELLET,
  'Cream Dosing': DosingMethodEnum.CREAM,
  'Troche Dosing': DosingMethodEnum.TROCHE,
  'Injectable Dosing': DosingMethodEnum.INJECTABLE,
};
